export const Territories = Object.freeze([
  { postalCode: 'NSW', label: 'New South Wales' },
  { postalCode: 'VIC', label: 'Victoria' },
  { postalCode: 'QLD', label: 'Queensland' },
  { postalCode: 'WA', label: 'Western Australia' },
  { postalCode: 'SA', label: 'South Australia' },
  { postalCode: 'TAS', label: 'Tasmania' },
  { postalCode: 'NT', label: 'Northern Territory' },
]);



// WEBPACK FOOTER //
// ./src/api/siteDesignations/australian-territories.js